export default { featurePreferences: false };
